import React, { useState, useEffect, useContext } from "react";
import { Form, Row, Col, Button, Image } from "react-bootstrap";
import { useHistory } from "react-router";
import { BASE_URL_API, BASE_URL_API_TRANXT_API, BASE_URL_APISERVICES } from "../../utils/Constants";
import cogoToast from "cogo-toast";
import swal from "sweetalert";
import { GlobalContext } from "../../Context/GlobalState";
import Select from "react-select";
import { RetailerApi_Endpoint } from "../../utils/RetailerApiEndpoint";

const ODDocSubmit = () => {
    const initialState = {
        version: "",
        user: { label: "Select User", value: "" },
    };

    const [state, setState] = useState(initialState);
    const [users, setUsers] = useState([]);
    const [kycData, setKycData] = useState({});
    const { user, setTransactionLoaderState, Profileinfo } = useContext(GlobalContext);
    const history = useHistory();
    const [uploadedDocs, setUploadedDoc] = useState({
        agreement_1: false,
        agreement_2: false,
        agreement_3: false,
        cheque: false,
    });
    const [uploadedDocsName, setUploadedDocsName] = useState({
        agreement_1: "",
        agreement_2: "",
        agreement_3: "",
        cheque: "",
    });
    const userId = JSON.parse(localStorage.getItem("kyc"));

    const Back = () => {
        history.push("/kyc/document-details");
    };
    const [formValues, setFormValues] = useState({
        PAN: "",
        AdharFront: "",
        AdharBack: "",
        GstDoc: "",
        Userimage: "",
        UserSign: "",
        UserImageWithAdhar: "",
        ShopImage: "",
        distributor: false,
        retailer: false,
    });
    const [formErrors, setFormErrors] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);
    const MN = sessionStorage.getItem("MN");
    const steps = localStorage.getItem("steps");
    const [showTerms, setShowTerms] = useState(false);

    const toggleTerms = () => {
        setShowTerms(!showTerms);
    };


    const convertToBiteArray = (file, callback) => {
        const reader = new FileReader();
        const fileByteArray = [];
        reader.readAsArrayBuffer(file);
        reader.onloadend = (evt) => {
            if (evt.target.readyState === FileReader.DONE) {
                const arrayBuffer = evt.target.result,
                    array = new Uint8Array(arrayBuffer);
                var binary = "";
                var len = array.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(array[i]);
                }
                callback(window.btoa(binary));
            }
        };
    };

    const ImageUpload = (e) => {
        if (state.user.value == "") {
            swal("Invalid", "Please Select User First", "error");
            return;
        }
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
        const type = e.target.id;

        if (e.target.files.length > 0) {
            if (e.target.files[0].size > 256000) {
                swal("Invalid", "Image Size should be less than 256 kb", "error");
                return;
            }
            convertToBiteArray(e.target.files[0], (ByteArray) => {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = JSON.stringify({
                    imagename: `OD_${state.user.value}_${type}`,
                    imagebytedata: ByteArray,
                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow",
                };

                try {
                    fetch(
                        `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.PAYMENT_IMAGE_UPLOAD}`,
                        requestOptions
                    )
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.status == "0") {
                                setUploadedDoc({ ...uploadedDocs, [type]: true });
                                setUploadedDocsName({
                                    ...uploadedDocsName,
                                    [type]: `OD_${state.user.value}_${type}`,
                                });
                                cogoToast.success(result.msg);
                                // verificationData();
                                // setUploadedImage();
                            } else {
                                cogoToast.error(result.msg);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                } catch (error) {
                    console.log(error);
                }
            });
        }
    };

    const validate = () => {
        const errors = {};

        if (!uploadedDocs.agreement_1) {
            errors.agreement_1 = "*Agreement Page 1 required!";
        }
        if (!uploadedDocs.agreement_2) {
            errors.agreement_2 = "*Agreement Page 2 required!";
        }
        if (!uploadedDocs.agreement_3) {
            errors.agreement_3 = "*Agreement Page 3 required!";
        }
        if (!uploadedDocs.cheque) {
            errors.cheque = "*Cheque required!";
        }

        if (!formValues.distributor || !formValues.retailer) {
            errors.checkbox = "*Both checkboxes are mandatory!";
        }

        setFormErrors(errors);

        if (Object.keys(errors).length === 0) {
            submitODRequest();
        }
    };

    const submitODRequest = async () => {
        try {
            setTransactionLoaderState(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                userid: state.user.value,
                agreement_1: uploadedDocsName.agreement_1,
                agreement_2: uploadedDocsName.agreement_2,
                agreement_3: uploadedDocsName.agreement_3,
                cheque: uploadedDocsName.cheque,
                docCollectedBy: formValues.selectedCheckbox,
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}${RetailerApi_Endpoint.ADMIN_OD_REQUEST_DOC_SUBMIT}`,
                requestOptions
            );
            const data = await res.json();
            if (data.status == "0") {
                swal("Success", data.msg, "success");
            } else {
                swal("Failed", data.msg, "error");
            }
            setTransactionLoaderState(false);
            clearForm();
        } catch (error) {
            setTransactionLoaderState(false);
            console.log("error", error);
        }
    };

    const getAllUserList = async () => {
        try {
            setTransactionLoaderState(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                usertype: "",
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_API}${RetailerApi_Endpoint.GET_ALL_USER_LIST_ADMIN}`,
                requestOptions
            );
            const data = await res.json();
            setUsers(
                data.data.map((user) => {
                    return {
                        ...user,
                        value: user.uCode,
                        label: `${user.uName} [${user.uCode}]`,
                    };
                })
            );
            setTransactionLoaderState(false);
        } catch (error) {
            setTransactionLoaderState(false);
            console.log("error", error);
        }
    };
    const clearForm = () => {
        setFormValues({
            agreement_1: "",
            agreement_2: "",
            agreement_3: "",
            cheque: "",
        });
        setState({
            version: "",
            user: { label: "Select User", value: "" },
        });
    };

    //   const clearForm = () => {
    //     setFormValues({
    //       PAN: "",
    //       AdharFront: "",
    //       AdharBack: "",
    //       GstDoc: "",
    //       Userimage: "",
    //       UserSign: "",
    //       UserImageWithAdhar: "",
    //       ShopImage: "",
    //       distributor: false,
    //       retailer: false,
    //     });
    //     setUploadedDocs({});
    //     setFormErrors({});
    //   };
    useEffect(() => {
        getAllUserList();
    }, []);


    return (
        <div className="p-4" style={{ fontFamily: "auto" }}>
            <div style={{ padding: "1rem" }} className="bg-light ">
                <div
                    style={{ borderRadius: "10px" }}
                    className="card  p-0 m-0 mx-2 mt-4 "
                >
                    <div className="card-body m-0 p-3">
                        <div>
                            <div
                                style={{
                                    fontFamily: "Poppins",
                                    fontWeight: "bolder",
                                    fontSize: "28px",
                                    lineHeight: "48px",
                                    textAlign: "left",
                                    color: "#4267B2",
                                    background: "#FFFFFF",
                                }}
                            >
                                OD Request Document Upload
                            </div>

                            <div>
                                <div className="col-10 m-0 p-0">
                                    <div className="row m-0 p-0">
                                        <div className="col-6 p-0 pr-2">
                                            <Form.Group>
                                                <Form.Label>
                                                    <span style={{ color: "red" }}>*</span>
                                                    <span style={{ color: "black" }}>User Code</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className="form-control rounded-100"
                                                    placeholder="User Code"
                                                    maxLength="10"
                                                    value={user.ReferId}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </div>

                                        <div className="col-6 p-0 pl-2 ">
                                            <Form.Group>
                                                <Form.Label>
                                                    <span style={{ color: "red" }}>*</span>
                                                    <span style={{ color: "black" }}>User Name</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className="form-control rounded-100"
                                                    placeholder="User Name"
                                                    maxLength="10"
                                                    value={Profileinfo?.shopname}
                                                    disabled
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>

                                <Row className="mt-2 col-12">
                                    <Col className="col-12 col-sm-6 col-md-4 text-left">
                                        <Form.Label>
                                            <b>Agreement Page 1</b>
                                            <span style={{ color: "red" }}>*</span>
                                        </Form.Label>
                                        <Image
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                maxHeight: "30vh",
                                                maxWidth: "30vw",
                                            }}
                                            src={kycData.imgaadharback}
                                        />
                                        <Form.Control
                                            accept=".jpg,.png"
                                            type="file"
                                            name="agreement_1"
                                            value={formValues.agreement_1}
                                            id="agreement_1"
                                            onChange={ImageUpload}
                                        />
                                        <p style={{ color: "red" }}>{formErrors.agreement_1}</p>
                                    </Col>

                                    <Col className="col-12 col-sm-6 col-md-4 text-left">
                                        <Form.Label>
                                            <b>Agreement Page 2</b>
                                            <span style={{ color: "red" }}>*</span>
                                        </Form.Label>
                                        <Image
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                maxHeight: "30vh",
                                                maxWidth: "30vw",
                                            }}
                                            src={kycData.signature}
                                        />
                                        <Form.Control
                                            accept=".jpg,.png"
                                            type="file"
                                            name="agreement_2"
                                            value={formValues.agreement_2}
                                            id="agreement_2"
                                            onChange={ImageUpload}
                                        />
                                        <p style={{ color: "red" }}>{formErrors.agreement_2}</p>
                                    </Col>

                                    <Col md={3} lg={3} sm={6} className="text-left">
                                        <Form.Label>
                                            <b>Agreement Page 3</b>
                                        </Form.Label>
                                        <Image
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                maxHeight: "30vh",
                                                maxWidth: "30vw",
                                            }}
                                            src={kycData.gstdoc}
                                        />
                                        <Form.Control
                                            accept=".jpg,.png"
                                            type="file"
                                            name="agreement_3"
                                            value={formValues.agreement_3}
                                            id="agreement_3"
                                            onChange={ImageUpload}
                                        />
                                        <p style={{ color: "red" }}>{formErrors.agreement_3}</p>
                                    </Col>

                                    <Col md={3} lg={3} sm={6} className="text-left">
                                        <Form.Label>
                                            <b>Cheque</b>
                                        </Form.Label>
                                        <Image
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                maxHeight: "30vh",
                                                maxWidth: "30vw",
                                            }}
                                            src={kycData.gstdoc}
                                        />
                                        <Form.Control
                                            accept=".jpg,.png"
                                            type="file"
                                            name="cheque"
                                            value={formValues.cheque}
                                            id="cheque"
                                            onChange={ImageUpload}
                                        />
                                        <p style={{ color: "red" }}>{formErrors.cheque}</p>
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div className="mt-3">
                            <div className="col-12">
                                <Form.Check
                                    type="checkbox"
                                    id="distributor"
                                    label="Document Collected by distributor"
                                    checked={formValues.distributor}
                                    onChange={(e) =>
                                        setFormValues({ ...formValues, distributor: e.target.checked })
                                    }
                                />

                                <Form.Check
                                    type="checkbox"
                                    id="Retailer"
                                    label="I confirm that I am submitting the hard copy of the required documents to the distributor and the soft copy to the company."
                                    checked={formValues.retailer}
                                    onChange={(e) =>
                                        setFormValues({ ...formValues, retailer: e.target.checked })
                                    }
                                />

                                {formErrors.checkbox && (
                                    <p style={{ color: "red" }}>{formErrors.checkbox}</p>
                                )}
                            </div>

                            <span
                                className="ml-3"
                                onClick={toggleTerms}
                                style={{
                                    color: "#4267B2",
                                    fontWeight: "600",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                }}
                            >
                                {showTerms ? "Hide Terms & Conditions" : "Read Terms & Conditions"}
                            </span>

                            {showTerms && (
                                <div
                                    className="mt-3 p-3"
                                    style={{
                                        border: "1px solid #ccc",
                                        borderRadius: "10px",
                                        background: "#f9f9f9",
                                        fontSize: "14px",
                                        fontFamily: "Poppins",
                                    }}
                                >
                                    <h5 style={{ color: "#4267B2", fontWeight: "700" }}>
                                        Terms & Conditions
                                    </h5>
                                    <ol style={{ paddingLeft: "20px" }}>
                                        <li>
                                            Maximum credit limit for the first 3 months will be ₹25,000.
                                        </li>
                                        <li>
                                            Advance credit must be cleared on the same day, no later than{" "}
                                            <b>12:00 AM (midnight)</b>.
                                        </li>
                                        <li>
                                            In case of failure to maintain required balance, a penalty
                                            charge of <b>0.25%</b> per day will be deducted until the
                                            balance is restored.
                                        </li>
                                        <li>
                                            The company shall not be held liable for any misuse,
                                            unauthorized handling, or fraudulent use of documents. The
                                            responsibility lies solely with the account holder.
                                        </li>
                                        <li>
                                            The company reserves the right to amend or update these terms
                                            and conditions without prior notice.
                                        </li>
                                    </ol>
                                </div>
                            )}
                        </div>

                        <div className="">
                            <div className="row">
                                <div className="col-2 p-0 ml-2">
                                    <Button
                                        className="rounded-50 btn btn-primary btn-lg btn-block"
                                        onClick={validate}
                                    >
                                        Submit
                                    </Button>
                                </div>
                                <div className="col-2 p-0 ml-2">
                                    <Button
                                        className="rounded-50 btn border-primary btn-lg btn-block bg-white border text-primary"
                                        onClick={clearForm}
                                    >
                                        Clear
                                    </Button>
                                </div>
                                <div className="col p-0"></div>
                                <div className="col p-0"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ODDocSubmit;